import React, {useState} from "react";
import {Box, Button, Columns, Form, Table} from "react-bulma-components";
import Collapsible from "react-collapsible";
import NewOptionRow from "./NewOptionRow"
import axios from "axios";


export default function NewCategory({onSave}){
    const [category, setCategory] = useState({
        options: [],
        name: "",
        status: "Active"
    });

    const onChange = e => {
        let newCategory = {...category, [e.target.name]: e.target.value}
        setCategory(newCategory);
    }
    const newOption = () => {
        let newOption = {
            name: "",
            status: "ACTIVE"
        }
        let options = [...category.options];
        options.push(newOption);
        const toUpdate = {
            target: {
                name: "options",
                value: options
            }
        };
        onChange(toUpdate);
    }
    const onOptionChange = (e, index) => {
        let newOption = {...category.options[index], [e.target.name]: e.target.value}
        let newOptions = [...category.options]
        newOptions[index] = newOption
        const toUpdate = {
            target: {
                name: "options",
                value: newOptions
            }
        };
        onChange(toUpdate);
    }


    return (
        <Box>
            <Collapsible
                trigger={"New Category"}
                triggerOpenedClassName={"title"}
                className={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Form.Label>Category Name</Form.Label>
                        <Form.Input
                            type={"text"}
                            name={"name"}
                            value={category.name}
                            onChange={onChange}
                        />
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {category.options.map((option, index) => (
                                    <NewOptionRow
                                        option={option}
                                        index={index}
                                        onChange={onOptionChange}
                                    />
                                ))}
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"info"}
                            onClick={newOption}
                        >
                            New Option
                        </Button>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            fullwidth
                            onClick={() => onSave(category)}
                        >
                            Save
                        </Button>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )




}